import axios from 'axios'
import { logoutUser, isTokenError } from '../utils/authUtils'

export const getDomain = () => {
  const API_URL = process.env.REACT_APP_API_URL || ''
  return (API_URL || 'http://localhost:6017').replace(/\/$/gi, '')
}

const http = axios.create({
  baseURL: getDomain()
})

http.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('accessToken') || localStorage.getItem('accessToken');
    if (token) config.headers['Authorization'] = 'Bearer ' + token;
    return config;
  },
  (error) => Promise.reject(error)
);

http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (isTokenError(error)) {
      // Не разлогиниваем на публичных страницах
      const publicPaths = ['/login', '/register', '/reset-password', '/admin/activate'];
      if (!publicPaths.some(path => window.location.pathname.startsWith(path))) {
        console.warn('Token error detected, logging out user:', error.response.data);
        logoutUser();
      }
      return Promise.reject(error);
    }
    
    return Promise.reject(error);
  }
);
function getToken (key?: string):string {
  try {
    return JSON.parse(localStorage.getItem('user') || '')[key || 'access_token'] || 'no token'
  } catch(e) {
    return '---'
  }
}


function getHeaders (headers:any) {
    return {...headers || {}, authorization: getToken()}
}



const get = (url: string, params = {}, headers = {}) => {
  return http.get(url, {
    params: { ...params },
    headers: {
      ...getHeaders(headers),
    },
  })
}

export const post = (url: string, data: object | any, headers = {}, params = {}) => {
  return http.post(url, data, {
    ...params,
    headers: {
      ...getHeaders(headers),
    },
  })
}

const put = (url: string, data: object | any, headers = {}) => {
  return http.put(url, data, {
    headers: {
      ...getHeaders(headers),

    },
  })
}

export const remove = (url: string, data: object | any, headers = {}, params = {}) => {
  return http.delete(url, {
    params: { ...params },
    headers: {
      ...getHeaders(headers),

    },
    data,
  })
}
const patch = (url: string, data: object | any, headers = {}) => {
  return http.patch(url, data, {
    headers: {
      ...getHeaders(headers),
    },
  })
}

export default {
  http,
  get,
  post,
  put,
  remove,
  patch,
}
